import React from 'react';
import Seo from '../Seo/Seo';
import './CookiesPolicy.css';

const CookiesPolicy = () => {
  return (
    <>
      <Seo
        title="Cookies Policy | ZealFC"
        description="Read the ZealFC cookies policy and understand what necessary cookies are used for login, security, and payments."
        canonicalPath="/cookies"
      />
      <div className="cookies-policy">
        <h1>Cookies Policy</h1>
        <p><strong>Last updated:</strong> February 23, 2026</p>

      <h2>Controller</h2>
      <p>ZealFC (<a href="mailto:contact@zealfc.com">contact@zealfc.com</a>)</p>

      <h2>What We Use</h2>
      <ul>
        <li><strong>Strictly necessary (legitimate interest / contract):</strong> session/auth tokens (localStorage) to keep you logged in; Cloudflare/edge protection (e.g., <code>cf_clearance</code>) for security; Stripe Checkout cookies (<code>__stripe_mid</code>, <code>__stripe_sid</code>, <code>m</code>) only when you start a payment, to prevent fraud and complete the transaction.</li>
        <li><strong>Preference / Analytics / Marketing:</strong> Not used. We do not run analytics, ads, or other optional trackers.</li>
      </ul>

      <h2>Retention</h2>
      <ul>
        <li>Session/auth tokens: until you log out or delete them.</li>
        <li>Stripe cookies: per Stripe’s security schedule (see Stripe’s cookie notice).</li>
        <li>Cloudflare security cookies: short-lived, managed by Cloudflare.</li>
      </ul>

      <h2>Your Choices</h2>
      <ul>
        <li>Optional cookies: currently none. If added in future, we will ask before setting them.</li>
        <li>Change/withdraw consent: use “Cookie settings” in the footer or clear cookies in your browser; this immediately disables any optional cookies (none today).</li>
        <li>Browser controls: you can block or delete cookies in your browser. Blocking strictly necessary cookies may break login or checkout.</li>
      </ul>

      <h2>Third Parties</h2>
      <ul>
        <li>Stripe Payments Europe, Ltd. (payment processing cookies only when you initiate checkout).</li>
        <li>Cloudflare, Inc. (security).</li>
      </ul>

      <h2>Changes</h2>
      <p>We’ll post updates here with a new “Last updated” date.</p>

      <h2>Contact</h2>
      <p><a href="mailto:contact@zealfc.com">contact@zealfc.com</a> for any cookie/consent questions.</p>
      </div>
    </>
  );
};

export default CookiesPolicy;
